import { useEffect, useState } from "react";
import IMAGES from "../../../../assets/images/images";
import styles from "./quicklinksWidgets.module.css"
import QuickLinkPopup from "./quickLinkpopup/QuickLinkPopup";
import { connect } from "react-redux";
import Shimmer from "../../../../components/shimmer/Shimmer";
import { useNavigate } from "react-router-dom";
import { getQuickLinks } from "../../../../redux/actions/home/home.action";
import { AddQuickLink, DeleteQuickLink, EditQuickLink } from "../../../../redux/actions/home/quickLink.action";
import { openAlertPopup } from "../../../../redux/actions/Alert/alert.action";
import SecondaryTooltip from "../../../../components/secondaryToolTip/secondaryToolTip";
const QuickLinksWidget = ({action,quickLinks,...props}) => {
    const [isPopupOpen, setIsPopupOpen] = useState(false)
    const [linkDetail, setLinkDetail] = useState({isEditMode:false,isDeleteMode:false,item:{}});

    const togglePopup =(editMode,item)=>{
      setLinkDetail(prevState => ({...prevState,isEditMode:editMode,isDeleteMode:false,item:item?item:{}}));
      setIsPopupOpen(!isPopupOpen)
    }
    
    const gotoLink = (link) => {
        const normalizedLink = link.startsWith("http://") || link.startsWith("https://")? link: `https://${link}`;
        window.open(normalizedLink, "_blank");
    };

    useEffect(()=>{
        props?.getQuickLinks(action)
    },[])

    const retry =() =>{
      props?.getQuickLinks(action)
    }

    return(
        props?.isLoading?<Shimmer/>:<div className={styles.quicklinkcard}>
            <div className={styles.header}>
                <div className={styles.headertext}>Quick Links<span className={styles.maxlinknote}>Maximum 5 quick links.</span></div>
                {quickLinks?.links?.length===0&&!props?.isLoading&&
                <div className={styles.retryparent} onClick={retry}> <div className={styles.retryicon}></div><div className={styles.poplink}>Refresh</div></div>}
            </div>
            <div className={`${styles.quicklinkbody} ${quickLinks?.links?.length<4?"":styles.spacebtw}`}>
                {quickLinks?.links?.map((item,index)=>{
                    return(
                    <div key={index} className={`${styles.link} ${styles.normalwidth}`}>
                      <div className={styles.wrapper}>
                        <img src={IMAGES.editlink} className={`${styles.editlink} ${styles.selected}`} onClick={()=>togglePopup(true,item)} alt="Edit Link"/>
                      {/* </SecondaryTooltip> */}
                      <SecondaryTooltip text={item?.title} positions={['bottom', 'right']}>
                         <img src={IMAGES.quicklink} className={`${styles.quicklinkicon} ${item?.linkId ===linkDetail?.item?.linkId ? styles.selectedlink : ''}`} onClick={()=>gotoLink(item?.link_url)} />
                      </SecondaryTooltip>
                      </div>
                      {/* <SecondaryTooltip text={item?.title} positions={['bottom', 'right']}> */}
                        <div className={`${styles.linkname} ${styles.normallinkname}`}>{item?.title}</div>
                      {/* </SecondaryTooltip> */}
                    </div>
                )})}
                {quickLinks?.links?.length<5 && quickLinks?.links?.length !== 0 ?
                <div className={styles.link}>
                    <img src={IMAGES.addlink} className={styles.quicklinkicon} onClick={()=>togglePopup(false)} />
                    <div className={styles.linkname}></div>
                </div>
                :(quickLinks?.links?.length === 0 || Object?.keys(quickLinks)?.length===0) && <div className={styles.linkparent}>
                    <div className={styles.quicklink} onClick={()=>togglePopup(false)} ><span className={styles.plus}>+</span>Add Link</div>
                </div>}
                {isPopupOpen&&(<QuickLinkPopup action={action} setIsPopupOpen={setIsPopupOpen} isPopupOpen={isPopupOpen} AddQuickLink={props?.AddQuickLink} EditQuickLink={props?.EditQuickLink} DeleteQuickLink={props?.DeleteQuickLink} openAlertPopup={props?.openAlertPopup} getQuickLinks={props?.getQuickLinks} linkDetail={linkDetail} setLinkDetail={setLinkDetail} links={quickLinks?.links}/>)}
            </div>
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        quickLinks:state?.dashBoardCounts?.quickLinks?.data,
        isLoading:state?.dashBoardCounts?.quickLinks?.isLoading,
        myRights : state.myRights.myRights
    }
  }
  const mapDispatchToProps = (dispatch)=>{
    return {
        getQuickLinks: (action) => {
          return dispatch(getQuickLinks(action))
        },
        AddQuickLink: (action) => {
            return dispatch(AddQuickLink(action))
        },
        EditQuickLink: (action,id) => {
          return dispatch(EditQuickLink(action,id))
        },
        openAlertPopup: (payload) => {
            return dispatch(openAlertPopup(payload))
        },
        DeleteQuickLink: (id) => {
            return dispatch(DeleteQuickLink(id))
        },
    }
  }
export default connect(mapStateToProps,mapDispatchToProps)(QuickLinksWidget);